<template>
  <div class="container">
    <div class="selectconditons">
      <a-input
        ref="scode"
        v-model="inputGroup.source"
        placeholder="来源"
        style="width: 15%; margin-right: 2%"
        @pressEnter=";(pagination.current = 1), getTableDate()"
      >
        <a-icon slot="prefix" type="mobile" />
        <a-tooltip slot="suffix" title="要查找的来源信息">
          <a-icon type="info-circle" style="color: rgba(0, 0, 0, 0.45)" />
        </a-tooltip>
      </a-input>
      <a-button type="primary" icon="search" @click=";(pagination.current = 1), getTableDate()">搜索</a-button>
      <a-button type="primary" icon="plus" style="margin-left: 1%" @click="openAddModal()">添加一组信息</a-button>
      <a-modal v-model="addIndustryModal" title="添加账户信息" @ok="AddSourceOK()">
        <!-- 表单 start -->
        <a-row>
          <a-col :span="6">
            <span style="color: red; font-size: 18px;line-height：22px;align-text:center"> * </span>
            <span style="font-weight: 500">来源名称： </span>
          </a-col>
          <a-col :span="14">
            <a-input placeholder="来源名" v-model="sourceInfo.source" @blur="checkSourceName()" />
          </a-col>
          <a-col :span="4" v-if="showSourceIsEmpty">
            <p class="nullTips">来源名必填！</p>
          </a-col>
        </a-row>
        <a-row class="margin-top-10">
          <a-col :span="6">
            <span style="color: red; font-size: 18px;line-height：22px;align-text:center"> * </span>
            <span style="font-weight: 500">账号名称： </span>
          </a-col>
          <a-col :span="14">
            <a-select
              class="width-100-per"
              placeholder="账号名称"
              v-model="sourceInfo.syAccountSource"
              :options="syAccountSourceOptions"
            />
          </a-col>
          <a-col :span="4" v-if="showSourceTypeIsEmpty">
            <p class="nullTips">账号名称名必填！</p>
          </a-col>
        </a-row>
        <!-- 表单 end -->
      </a-modal>
      <a-modal v-model="visible" title="修改账户信息" @ok="sumitUpdateSource()">
        <!-- 表单 start -->
        <a-row>
          <a-col :span="6">
            <span style="color: red; font-size: 18px;line-height：22px;align-text:center"> * </span>
            <span style="font-weight: 500">来源名称： </span>
          </a-col>
          <a-col :span="14">
            <a-input placeholder="来源名" v-model="sourceInfo.source" @blur="checkSourceName()" />
          </a-col>
          <a-col :span="4" v-if="showSourceIsEmpty">
            <p class="nullTips">来源名必填！</p>
          </a-col>
        </a-row>
        <a-row class="margin-top-10">
          <a-col :span="6">
            <span style="color: red; font-size: 18px;line-height：22px;align-text:center"> * </span>
            <span style="font-weight: 500">账号名称： </span>
          </a-col>
          <a-col :span="14">
            <a-select
              class="width-100-per"
              placeholder="账号名称"
              v-model="sourceInfo.syAccountSource"
              :options="syAccountSourceOptions"
            />
          </a-col>
          <a-col :span="4" v-if="showSourceTypeIsEmpty">
            <p class="nullTips">账号名称名必填！</p>
          </a-col>
        </a-row>
        <!-- 表单 end -->
      </a-modal>
    </div>
    <div class="selectresulttable">
      <a-table
        :columns="columns"
        :data-source="data"
        :pagination="false"
        :loading="loading"
        bordered
        :scroll="{ x: true }"
      >
        <span slot="action" slot-scope="text, record">
          <a-button
            type="link"
            @click="editSource(record)"
            v-if="record.sources != '全部'"
            size="small"
            style="margin-right: 3px"
            >修改</a-button
          >
          <a-button
            type="link"
            style="color: #ff4d4f"
            v-if="record.sources != '全部'"
            @click="deleteSource(record)"
            size="small"
            >删除</a-button
          >
          <a-button type="link" @click="showDrawer(record)">配置用户</a-button>
          <a-button type="link" @click="openMangeSourcesAccount(record)">配置账号</a-button>
        </span>
      </a-table>
      <a-drawer
        title="配置用户可见来源"
        placement="right"
        :closable="false"
        :visible="drawerVisible"
        @close="onClose"
        width="60%"
      >
        <mange-sources-user @closeSourcesDrawer="closeSourcesDrawer" :sourcesid="sourcesid"></mange-sources-user>
      </a-drawer>
      <mange-sources-account ref="mangeSourcesAccount" />
      <div class="pageBar">
        <a-pagination
          style="margin-top: 1%; float: right"
          size="small"
          :current="pagination.current"
          :total="pagination.total"
          :show-total="(total, range) => `${range[0]}-${range[1]} 共 ${total} 条`"
          show-size-changer
          show-quick-jumper
          :showSizeChanger="true"
          :pageSize="pagination.pageSize"
          :pageSizeOptions="pagination.pageSizeOptions"
          @change="onChange"
          @showSizeChange="showSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getAllSources, delSources, updateSources, addSerouces, getSyAccountTypeList } from '@/api/api'
import moment from 'moment'
import mangeSourcesUser from './components/mangeSourcesUser'
import mangeSourcesAccount from './components/mangeSourcesAccount.vue'

//表格字段名称
const columns = [
  {
    title: '来源',
    dataIndex: 'sources',
    key: 'sources',
    width: 110,
  },
  {
    title: '账号',
    dataIndex: 'syAccountSource',
    key: 'syAccountSource',
    width: 110,
  },
  {
    title: '创建者',
    dataIndex: 'createBy',
    key: 'createBy',
    width: 100,
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    key: 'createTime',
    width: 100,
  },
  {
    title: '修改者',
    dataIndex: 'updateBy',
    key: 'updateBy',
    width: 100,
  },
  {
    title: '修改时间',
    dataIndex: 'updateTime',
    key: 'updateTime',
    width: 150,
  },
  {
    title: '注意',
    dataIndex: 'memo',
    key: 'memo',
    width: 100,
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
    width: 170,
  },
]

export default {
  components: {
    mangeSourcesUser,
    mangeSourcesAccount,
  },
  data() {
    return {
      columns,
      data: [],
      //页码数据
      pagination: {
        current: 1,
        total: 0,
        pageSizeOptions: ['5', '10', '15', '20'],
        pageSize: 10,
      },
      //查询参数
      inputGroup: {
        source: '',
      },
      //来源信息参数
      sourceInfo: {
        source: '',
        syAccountSource: undefined,
      },
      loading: false,
      visible: false,
      addIndustryModal: false,
      isChangeSource: false,
      chooseSourceID: '',
      rules: {
        source: [{ required: true, message: '请输入短信来源', trigger: 'blur' }],
      },
      messageType: [],
      drawerVisible: false,
      sourcesid: '',
      showSourceIsEmpty: false,
      showSourceTypeIsEmpty: false,
      syAccountSourceOptions: [],
    }
  },
  mounted() {
    this.getTableDate()
    this.getSyAccountTypeList()
  },
  methods: {
    getSyAccountTypeList() {
      getSyAccountTypeList()
        .then((res) => {
          if (res.code == 200) {
            this.syAccountSourceOptions = res.result.map((item) => {
              return {
                label: item,
                value: item,
              }
            })
          } else {
            this.$message.error(res.message)
          }
        })
        .catch((error) => {
          this.$message.error(error.message)
        })
    },
    checkSourceName() {
      if (this.sourceInfo.source == '') {
        this.showSourceIsEmpty = true
      } else {
        this.showSourceIsEmpty = false
      }
    },
    checkSourceType() {
      if (this.sourceInfo.syAccountSource == '') {
        this.showSourceTypeIsEmpty = true
      } else {
        this.showSourceTypeIsEmpty = false
      }
    },
    closeSourcesDrawer(data) {
      this.drawerVisible = data
    },
    showDrawer(records) {
      this.sourcesid = records.id
      this.drawerVisible = true
    },
    onClose() {
      this.drawerVisible = false
    },
    //获取选择器选项
    getMessageTypeOpenion() {
      getMessageType().then((res) => {
        this.messageType = res.result.value
        this.messageType.splice(0, 0, '')
      })
    },
    //修改选择器选择的值
    chooseWhat(value) {
      this.inputGroup.type = value
    },
    openAddModal() {
      this.cleanSourceInfo()
      this.addIndustryModal = true
    },
    //提交修改信息
    sumitUpdateSource() {
      let sumitDate = {
        sources: this.sourceInfo.source,
        sourcesId: this.chooseSourceID,
        syAccountSource: this.sourceInfo.syAccountSource,
        userName: this.$ls.get('Login_Userinfo').realname,
      }
      updateSources(sumitDate).then((res) => {
        if (res.success) {
          this.$message.success(res.message)
          this.visible = false
          this.cleanSourceInfo()
          this.getTableDate()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //添加账号信息
    AddSourceOK() {
      if (!this.sourceInfo.syAccountSource) {
        this.$message.error('请选择账号名称')
        return
      }
      let sumitDate = {
        sources: this.sourceInfo.source,
        syAccountSource: this.sourceInfo.syAccountSource,
        userName: this.$ls.get('Login_Userinfo').realname,
      }
      addSerouces(sumitDate).then((res) => {
        if (res.success) {
          this.$message.success(res.message)
          this.addIndustryModal = false
          this.cleanSourceInfo()
          this.getTableDate()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    editSource(source) {
      //先赋值
      this.showSourceIsEmpty = false
      this.sourceInfo.source = source.sources
      this.sourceInfo.syAccountSource = source.syAccountSource
      this.chooseSourceID = source.id
      //弹出添加信息的模态框
      this.visible = true
      this.isChangeSource = true
    },
    //清空输入框
    cleanSourceInfo() {
      this.sourceInfo.source = ''
      this.sourceInfo.syAccountSource = undefined
    },
    //删除账号信息二步确认
    deleteSource(source) {
      this.$antdConfirm({
        title: '是否删除名字为：' + source.sources + '的来源?',
        content: (h) => (
          <div style="color:red;">
            <a-icon type="info-circle" style="margin-right:10px" />
            删除操作不可恢复的哦
          </div>
        ),
        okText: '是',
        okType: 'danger',
        cancelText: '点错啦',
        onOk: () => {
          this.doDelete(source.id)
        },
        onCancel: () => {
          this.$message.success('感谢您的仁慈！')
        },
      })
    },
    //删除信息账号
    doDelete(id) {
      let delDate = {
        sourcesId: id,
      }
      delSources(delDate).then((res) => {
        if (res.success) {
          this.$message.success(res.message)
          this.getTableDate()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //页面换页重新获取表格数据
    onChange(page, pageSize) {
      this.pagination.current = page
      this.pagination.pageSize = pageSize
      this.getTableDate()
    },
    //页面容量修改时重新获取表格数据
    showSizeChange(current, size) {
      this.pagination.current = current
      this.pagination.pageSize = size
      this.getTableDate()
    },
    //获取表格数据
    getTableDate() {
      this.loading = true
      let requestDate = {
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        sources: this.inputGroup.source,
      }
      getAllSources(requestDate).then((res) => {
        if (res.success) {
          this.data = res.result.records
          this.pagination.current = res.result.current
          this.pagination.total = res.result.total
        } else {
          this.$message.error(res.message)
        }
        this.loading = false
      })
    },
    openMangeSourcesAccount(record) {
      this.$refs.mangeSourcesAccount.open(record)
    },
  },
}
</script>

<style scoped>
.container {
  background-color: #ffffff;
  height: 100%;
  width: 100%;
}
.selectconditons {
  padding-top: 1%;
  padding-left: 1%;
  background-color: #ffffff;
}
.selectresulttable {
  padding: 0.5%;
  background-color: #ffffff;
}
.pageBar {
  width: 100%;
  height: 3rem;
  background-color: #ffffff;
}
.nullTips {
  color: red;
  font-size: 12px;
  line-height: 22px;
  text-align: center;
  margin: auto;
}
.width-100-per {
  width: 100%;
}
.margin-top-10 {
  margin-top: 20px;
}
</style>
